import { render, staticRenderFns } from "./ChatbotFaqForm.vue?vue&type=template&id=44be3d5e&scoped=true"
import script from "./ChatbotFaqForm.vue?vue&type=script&lang=js"
export * from "./ChatbotFaqForm.vue?vue&type=script&lang=js"
import style0 from "./ChatbotFaqForm.vue?vue&type=style&index=0&id=44be3d5e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44be3d5e",
  null
  
)

export default component.exports